import React from 'react';
import Select from 'react-select';
import qs from 'qs';
import { useHistory, useLocation } from 'react-router';

import { fullPathWithParams, } from '../util';

export default function QuerySelector(props) {
  const { paramName = 'filter', defaultValue = [], label = '絞込み', isMulti = false, width = 200, options = [], disabled = false, isClearable = true, max, selectorProps, isSimple = false, maintainOrder = false, ...extraProps } = props;
  const history = useHistory();
  const location = useLocation();
  const { [paramName]: items = defaultValue } = qs.parse(decodeURI(location.search.slice(1)), { arrayLimit: Infinity });
  const onSelect = (selected) => {
    const value = isMulti ? ((max ? selected.slice(0, max) : selected) || []).map(_ => _.value) : (selected ? [selected.value] : []);
    const path = fullPathWithParams({ [paramName]: value, page: undefined, }, location);
    history.replace(encodeURI(path));
  };

  // 順序を維持する場合は、選択された順序でソート
  const selectedOptions = maintainOrder && isMulti && items
    ? items.map(itemValue => options.find(_ => _.value === itemValue)).filter(Boolean)
    : options.filter(_ => items && items.includes(_.value));

  return (
    <div style={{ width, }} {...extraProps}>
      <div className="text-muted small">{label}</div>
      <Select
        isMulti={isMulti}
        value={selectedOptions}
        options={options}
        onChange={onSelect}
        className="w-100"
        isDisabled={disabled}
        isClearable={isClearable}
        {...(isSimple && { components: { IndicatorsContainer: _ => null }, })}
        {...selectorProps}
      />
    </div>
  );
};
